import type { JSX } from 'react';
import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { useFlags } from '@feathr/report_components';

import FundraisePage from '../FundraisePage';
import DonationFormEditor from '../FundraisePage/DonationFormEditPage/DonationFormEditPage';
import DonationFormReportPage from '../FundraisePage/DonationFormReportPage';
import GrowthCreditsPage from '../FundraisePage/GrowthCreditsPage';
import ReceiptSettingsPage from '../FundraisePage/ReceiptSettingsPage';
import StripeOnboardingRedirect from '../FundraisePage/StripeOnboardingRedirect';
import RouteWithPermissions from './RouteWithPermissions';

function FundraiseRoutes(): JSX.Element {
  const { showFundraise, showGrowthCredits } = useFlags();

  return (
    <Switch>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/stripe/onboarding-url'}
      >
        <StripeOnboardingRedirect />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise && showGrowthCredits}
        exact={true}
        path={'/:accountId/fundraise/growth-credits'}
      >
        <GrowthCreditsPage />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/receipt-settings'}
      >
        <ReceiptSettingsPage />
      </RouteWithPermissions>
      <Redirect
        from={'/:accountId/fundraise/receipt-settings/*'}
        to={'/:accountId/fundraise/receipt-settings'}
      />
      <Redirect exact={true} from={'/:accountId/fundraise'} to={'/:accountId/fundraise/activity'} />
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:tab(activity|forms|settings)'}
      >
        <FundraisePage />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId'}
      >
        <DonationFormReportPage />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId/edit'}
      >
        <DonationFormEditor />
      </RouteWithPermissions>
    </Switch>
  );
}

export default FundraiseRoutes;
